export class SarSettings {
  constructor() {
    let overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const defaults = {
      width: {
        type: 'px',
        value: 500
      },
      height: {
        type: 'auto',
        value: 1
      },
      padding: {
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0,
        paddingBottom: 0
      },
      border: {
        borderWidth: 0,
        borderColor: '#000000',
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        borderStyle: 'solid'
      },
      background: '#ffffff',
      closeFont: {
        fontSize: 16,
        color: '#999999',
        fontFamily: 'arial, helvetica, sans-serif'
      },
      showClose: true,
      showVeil: true,
      veilColor: '#000000',
      veilOpacity: 0.65,
      defaultLanguage: 'EN',
      useBrowserDefault: false
    };
    Object.assign(this, defaults, overrides);
  }
}
;
export const SarTypes = {
  language: {
    language: {
      title: 'Default Language',
      type: 'Language'
    },
    useBrowserDefault: {
      title: 'Use Browser Default',
      type: 'Switch'
    }
  },
  settings: {
    lockScroll: {
      title: 'Disable Scrolling?',
      type: 'Switch'
    },
    url: {
      title: 'Website BG',
      type: 'Input'
    }
  },
  orientation: {
    width: {
      title: 'Width',
      type: 'Size'
    },
    height: {
      title: 'Height',
      type: 'Size'
    },
    padding: {
      title: 'Padding',
      type: 'Padding'
    }
  },
  styles: {
    background: {
      title: 'Background Color',
      type: 'ColorPicker'
    },
    border: {
      title: 'Border',
      type: 'Border'
    }
  },
  close: {
    showClose: {
      title: 'Show?',
      type: 'Switch'
    },
    closeAlign: {
      title: 'Align',
      type: 'Align'
    },
    closeFont: {
      title: 'Style',
      type: 'Font'
    }
  },
  veil: {
    showVeil: {
      title: 'Show?',
      type: 'Switch'
    },
    veilColor: {
      title: 'Color',
      type: 'ColorPicker'
    },
    veilOpacity: {
      title: 'Opacity',
      type: 'Opacity'
    }
  }
};